export class HipaaSignatureInfo {    
    //TODO: Possibly get insured/agent information from appentry
    IsConsumerReportChecked: boolean;
    IsHipaaFormsAccessChecked: boolean;
    IsInformationMisrepresentationChecked: boolean
    IsTermsOfUseCheckboxChecked: boolean; 
    policyNumber: string;
    insuredName: string;
    insuredSignature: string;
    insuredDOB: string;
    insuredSSN: string;
    insuredEmailAddress: string;
    ipAddress: string;
    agentName: string;
    agentLicenseNumber: string;
    applicationState: string;
    applicationId: string;
    constructor() {
        this.IsConsumerReportChecked = false;
        this.IsHipaaFormsAccessChecked = false;
        this.IsInformationMisrepresentationChecked = false;
        this.IsTermsOfUseCheckboxChecked = false;
        this.policyNumber = '';
        this.insuredName  = '';
        this.insuredSignature = '';
        this.insuredDOB = '';
        this.insuredSSN = '';
        this.ipAddress = '';
        this.insuredEmailAddress = '';
        this.agentName = '';
        this.agentLicenseNumber = '';
        this.applicationState = '';
        this.applicationId = '';
    } 
 }